import { useEffect, useState } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getRoot, $insertNodes, EditorState } from 'lexical'
import {
	$generateHtmlFromNodes,
	$generateNodesFromDOM,
} from '@lexical/html'

export type OnChangePluginProps = {
	onChange: (editorState: EditorState, html: string) => void
	initialValue?: string
}

export default function OnChangePlugin({
	onChange,
	initialValue,
}: OnChangePluginProps) {
	const [editor] = useLexicalComposerContext()
	const [isInitialLoad, setIsInitialLoad] = useState(true)

	useEffect(() => {
		return editor.registerUpdateListener(({ editorState }) => {
			editorState.read(() => {
				const html = $generateHtmlFromNodes(editor, null)
				onChange(editorState, html)
			})
		})
	}, [editor, onChange])

	useEffect(() => {
		if (!initialValue || !isInitialLoad) return
		editor.update(() => {
			const parser = new DOMParser()
			const dom = parser.parseFromString(initialValue, 'text/html')
			const nodes = $generateNodesFromDOM(editor, dom)
			$getRoot().clear()
			$insertNodes(nodes)
		})
		setIsInitialLoad(false)
	}, [editor, initialValue, isInitialLoad])
	return null
}
